import * as React from "react";
import { motion } from "framer-motion";

function HowDoesItWork() {
  return (
    <div className="flex flex-col items-center px-16 pt-6 pb-14 bg-dark-indigo max-md:px-5">
      <div className="flex flex-col w-full max-w-[1120px] max-md:max-w-full">
        <div className="self-center text-2xl sm:text-5xl font-medium leading-10 text-center text-white capitalize">
          How Does it Work?
        </div>
        <div className="mt-9 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full shadow-xl">
              <motion.div className="flex max-md:mt-8 max-md:max-w-full grow"
                initial={{ opacity: 0, translateX: -200 }}
                whileInView={{ opacity: 1, translateX: 0 }}
                transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                viewport={{ once: true }} 
              >
                <div className="justify-center items-start px-4 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg max-md:pr-5 max-md:text-4xl">
                  1
                </div>
                <div className="grow pt-3 pb-7 text-lg text-color bg-white rounded-r-lg w-fit max-md:max-w-full pl-2">
                  <span className="text-xl font-medium leading-5">
                    Submit Your Project Request
                  </span>
                  <br />
                  <span className="leading-5">
                    To kickstart your project, email us at
                  </span>{" "} request@expertefy.com with details including the project
                  scope, proposal, and deliverables.
                </div>
              </motion.div>
            </div>
            <motion.div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full shadow-xl"
              initial={{ opacity: 0, translateX: 200 }}
              whileInView={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} >
              <div className="flex max-md:mt-8 grow">
                <div className="justify-center px-3.5 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg leading-[60px] max-md:text-4xl">
                  2
                </div>
                <div className="grow justify-center px-2 py-2.5 text-lg text-color bg-white rounded-r-lg w-fit max-md:pr-5 max-md:max-w-full pl-2">
                  <span className="text-xl font-medium text-color">
                    Project Launch
                  </span>
                  <br />
                  <span className="leading-5 text-color">
                    Upon receiving your request, Expertefy initiates the{" "}
                  </span>
                  project. We employ a dual approach, custom-recruiting and
                  simultaneously scanning our internal network to find the
                  perfect match for your needs.
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="mt-6 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <motion.div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full shadow-xl"
              initial={{ opacity: 0, translateX: -200 }}
              whileInView={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} >

              <div className="flex max-md:mt-8 grow">
                <div className="justify-center px-3.5 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg leading-[60px] max-md:text-4xl">
                  3
                </div>
                <div className="grow justify-center px-2 py-2.5 text-lg text-color bg-white rounded-r-lg shadow-md w-fit max-md:pr-5 max-md:max-w-full pl-2">
                  <span className="text-xl font-medium">Expert Selection</span>
                  <br />
                  <span className="leading-5">
                    Our team carefully screens potential candidates from
                  </span>{" "}
                  relevant industries and presents you with a curated list of
                  professionals. Each profile is briefly summarized to aid in
                  your selection process.
                </div>
              </div>
            </motion.div>
            
            <motion.div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full shadow-xl"
              initial={{ opacity: 0, translateX: 200 }}
              whileInView={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} >
              <div className="flex max-md:mt-8 grow">
                <div className="justify-center px-3 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg leading-[60px] max-md:text-4xl">
                  4
                </div>
                <div className="grow pt-3 pb-7 text-lg text-color bg-white rounded-r-lg shadow-md w-fit max-md:max-w-full pl-2">
                  <span className="text-xl font-medium">Expert Interview</span>
                  <br />
                  <span className="leading-5">
                    Expertefy arranges a consultation between you and
                  </span>{" "}
                  your chosen expert. If preferred, our team can also moderate
                  these discussions on your behalf.
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="mt-6 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            <motion.div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full shadow-xl"
              initial={{ opacity: 0, translateX: -200 }}
              whileInView={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} 
            >
              <div className="flex max-md:mt-8 grow">
                <div className="justify-center px-3.5 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg leading-[60px] max-md:text-4xl">
                  5
                </div>
                <div className="grow pt-2.5 pb-12 text-lg text-color bg-white rounded-r-lg shadow-md w-fit max-md:max-w-full pl-2">
                  <span className="text-xl font-medium">Project Delivery</span>
                  <br />
                  <span className="leading-5">
                    Expertefy compiles and delivers all project outputs,{" "}
                  </span>
                  including transcripts and audio recordings.
                </div>
              </div>
            </motion.div>

            <motion.div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full shadow-xl"
              initial={{ opacity: 0, translateX: 200 }}
              whileInView={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
              viewport={{ once: true }} 
            >
              <div className="flex max-md:mt-8 grow">
                <div className="justify-center px-3.5 py-11 text-6xl font-light text-center text-white whitespace-nowrap bg-light-indigo rounded-l-lg leading-[60px] max-md:text-4xl">
                  6
                </div>
                <div className="grow justify-center px-2 py-2.5 text-lg text-color bg-white rounded-r-lg shadow-md w-fit max-md:pr-5 max-md:max-w-full pl-2">
                  <span className="text-xl font-medium">
                    Follow-Up Inquiry Support
                  </span>
                  <br />
                  <span className="leading-5">
                    Following the consultation, if the client has additional
                  </span>{" "}
                  questions requiring further expert input, Expertefy will try
                  to facilitate these follow-up inquiries without extra charges.
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowDoesItWork;
